/*
 * File: PreferenceList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the "app-wide" settings on the Preferences page.
 */
import React, { useState } from "react";
import PubSub from "pubsub-js";
import UIFilterForm from "components/filter-view/UIFilterForm";
import Preferences from "services/preferences/Store";
import PreferenceFields from "../PreferenceFields";
import { useStore } from "utils/useStore";

const PreferenceList = () => {
  const preferencesStore = useStore(Preferences);
  // Create a copy of the PreferenceFields list with the value filled in from the store on the first render. (Functions passed to useState are called on first render and the return value used as initial state)
  const [fields, setFields] = useState(() =>
    PreferenceFields.map(field => ({
      ...field,
      value: field.name != null ? preferencesStore.get(field.name) : undefined
    }))
  );

  const handleChange = (key, changeValue) => {
    let value;

    if (key === "defaultView" || key === "autoLogout") {
      // These values are string representations of numbers, parse them before updating the preference.
      value = parseInt(changeValue);
    } else {
      // Other values can be passed on as is.
      value = changeValue;
    }

    setFields(prev => {
      // Create a copy of the array.
      const newFields = Array.from(prev);
      const index = newFields.findIndex(pref => pref.name === key);
      const oldField = newFields[index];
      // Create a new object with the same fields as the old one, with the new value at the position of the changed field.
      newFields[index] = { ...oldField, value };
      return newFields;
    });

    preferencesStore.apply(key, value);
    PubSub.publish("PREFERENCE_CHANGE", { key: key, value: value });
  };
  return <UIFilterForm fields={fields} parentOnChange={handleChange} />;
};

export default PreferenceList;
